import React from 'react';
import { PrimaryButton } from '../index';
import { useAnalytics } from '../../../hooks/use-analytics';

interface Props {
    recallsTradeInData: string;
}

export const FusionTradeInButton = (props: Props) => {
    const [fireEvents] = useAnalytics();
    return (
        <div
            className="recalls-fusion-trade-in-button"
            data-testid="fusion-tradeIn-button-component"
        >
            <PrimaryButton
                className=""
                fill={'fill'}
                color={'dark'}
                chevron={true}
                href={props.recallsTradeInData}
                onClick={() => {
                    fireEvents(
                        'recalls-fusion-trade-in-button',
                        undefined,
                        undefined,
                        false
                    );
                }}
            >
                Vehicle Refund Estimator
            </PrimaryButton>
        </div>
    );
};
